




































































































































































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import KendoChart from '@/components/kendo-chart/kendo-chart.vue';
import { DIRECT_SALES_ROUTES } from '@/modules/direct-sales/router';
import { numeralService, stringService, httpService, traceLogAccess } from '@/services';
import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import { CONFIG } from '@/config';
import PageLoader from '@/components/page-loader/page-loader.vue';
import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue';
import KendoMultiselect from '@/components/kendo-multiselect/kendo-simple-multiselect.vue';
import KendoDatepicker from '@/components/kendo-datepicker/kendo-datepicker.vue';
import { DirectSalesSpreadsheetFactory } from '@/modules/direct-sales/services/direct-sales-spreadsheet.factory.ts';
import { DirectSalesSpreadsheetType } from '@/modules/direct-sales/enums/direct-sales-spreadsheet.enum.ts';
import { PageContextName } from '@/enums';

@Component({
  components: {
    ActionBar,
    KendoChart,
    PageLoader,
    KendoDropdown,
    KendoMultiselect,
    KendoDatepicker
  }
})
export default class DirectSalesHomePage extends Vue {
  @Prop({ required: false })
  idGroup: number;

  @Prop({ required: false })
  idStore: number;

  public state: any = {
    data: [],
    stores: [],
    groups: [],
    storeSelected: {},
    groupSelected: {},
    channelRanking: 0,
    sizeRanking: 0,
    cityRanking: 0,
    order: 'asc',
    columnOrder: {
      text: 'Score total',
      value: 'propensityScoreValue'
    },
    dateInitial: new Date(
      moment()
        .subtract(5, 'years')
        .format()
    ),
    dateFinal: new Date()
  };

  public columnOrderDataSource = [
    {
      text: 'Score total',
      value: 'propensityScoreValue'
    },
    {
      text: 'Canal',
      value: 'salesChannelName'
    },
    {
      text: 'Porte',
      value: 'size'
    },
    {
      text: 'CNPJ',
      value: 'cnpjRoot'
    },
    {
      text: 'Qtd CNPJ',
      value: 'qtdFiliais'
    },
    {
      text: 'Razão social',
      value: 'name'
    },
    {
      text: 'UF',
      value: 'uf'
    },
    {
      text: 'Cidade-Sede',
      value: 'city'
    },
    {
      text: 'Frequência de Compra',
      value: 'frequencyProspectValue'
    }
  ];

  public numeral = numeral;

  public setGroup(groupValue) {
    this.state.storeSelected = {};
    this.state.stores = [];
    this.state.data = [];
    if (groupValue == 0) {
      this.state.groupSelected = {};
      return;
    }

    this.state.groupSelected = _.filter(this.state.groups, f => f.value == groupValue)[0];
    this.getStoresUser();
  }

  public setStore(idStore: any) {
    this.state.data = [];

    if (idStore == 0) {
      this.state.storeSelected = {};
      return;
    }

    this.state.storeSelected = _.filter(this.state.stores, f => f.value == idStore)[0];

    if (this.state.storeSelected.value) {
      this.getRanking();
    }
  }

  public setDateInit(event: any) {
    this.state.dateInitial = event.value;
    if (this.state.storeSelected && this.state.storeSelected.value > 0) {
      this.getRanking();
    }
  }

  public setDateFim(event: any) {
    this.state.dateFinal = event.value;
    if (this.state.storeSelected && this.state.storeSelected.value > 0) {
      this.getRanking();
    }
  }

  public setOrder(orderValue: any) {
    this.state.columnOrder = _.filter(this.columnOrderDataSource, f => f.value == orderValue)[0];
  }

  public getStoresUser() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/stores/${this.state.groupSelected.value}`)
      .then((res: AxiosResponse) => {
        const stores: any[] = _(res.data)
          .map(d => ({
            value: d.id,
            text: d.name
          }))
          .orderBy('text')
          .value();

        this.state.stores = _(stores)
          .orderBy('text')
          .value();

        if (this.idStore) {
          this.state.storeSelected = _(stores)
            .filter((f: any) => {
              return f.value == this.idStore;
            })
            .value()[0];
          this.getRanking();
          return;
        }

        if (stores.length === 1) {
          this.state.storeSelected = stores[0];
          this.getRanking();
          return;
        }
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getGroupsUser() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/groups/`)
      .then((res: AxiosResponse) => {
        var groups: any[] = _(res.data)
          .map(d => ({
            value: d.value,
            text: d.text
          }))
          .orderBy('text')
          .value();

        this.state.groups = groups;

        if (this.idGroup) {
          this.state.groupSelected = _(groups)
            .filter((f: any) => {
              return f.value == this.idGroup;
            })
            .value()[0];
          this.getStoresUser();
          return;
        }

        if (groups.length === 1) {
          this.state.groupSelected = groups[0];
          this.getStoresUser();
          return;
        }
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public get GetRankingFilter() {
    this.state.order =
      this.state.columnOrder &&
      (this.state.columnOrder.value == 'propensityScoreValue' ||
        this.state.columnOrder.value == 'frequencyProspectValue')
        ? 'desc'
        : 'asc';

    return _(this.state.data)
      .filter((item: any) => {
        if (this.state.channelRanking == 0) {
          return true;
        } else if (item.salesChannelName == this.state.channelRanking) {
          return true;
        }
        return false;
      })
      .filter((item: any) => {
        if (this.state.sizeRanking == 0) {
          return true;
        } else if (item.size == this.state.sizeRanking) {
          return true;
        }
        return false;
      })
      .filter((item: any) => {
        if (this.state.cityRanking == 0) {
          return true;
        } else if (item.city == this.state.cityRanking) {
          return true;
        }
        return false;
      })
      .orderBy((item: any) => {
        if (this.state.columnOrder && this.state.columnOrder.value) {
          switch (this.state.columnOrder.value) {
            case 0:
              return item['propensityScoreValue'];
            case 'propensityScoreValue':
              return item['propensityScoreValue'];
            default:
              return item[this.state.columnOrder.value];
          }
        } else {
          return item['propensityScoreValue'];
        }
      }, this.state.order)
      .value();
  }

  public get getCanal() {
    return _(this.state.data)
      .filter((item: any) => {
        if (this.state.sizeRanking == 0) {
          return true;
        } else if (item.size == this.state.sizeRanking) {
          return true;
        }
        return false;
      })
      .filter((item: any) => {
        if (this.state.cityRanking == 0) {
          return true;
        } else if (item.city == this.state.cityRanking) {
          return true;
        }
        return false;
      })
      .map(m => ({ value: m.salesChannelName, text: m.salesChannelName }))
      .uniqBy('text')
      .orderBy('value')
      .value();
  }

  public getExcel() {
    const daraRankingFilter = this.GetRankingFilter;

    DirectSalesSpreadsheetFactory.get(DirectSalesSpreadsheetType.Farmer, daraRankingFilter)
      .create()
      .saveAsExcel();
  }

  public get getporte() {
    return _(this.state.data)
      .filter((item: any) => {
        if (this.state.channelRanking == 0) {
          return true;
        } else if (item.salesChannelName == this.state.channelRanking) {
          return true;
        }
        return false;
      })
      .filter((item: any) => {
        if (this.state.cityRanking == 0) {
          return true;
        } else if (item.city == this.state.cityRanking) {
          return true;
        }
        return false;
      })
      .map(m => ({ value: m.size, text: m.size }))
      .uniqBy('text')
      .orderBy('value')
      .value();
  }

  public get getcity() {
    return _(this.state.data)
      .filter((item: any) => {
        if (this.state.channelRanking == 0) {
          return true;
        } else if (item.salesChannelName == this.state.channelRanking) {
          return true;
        }
        return false;
      })
      .filter((item: any) => {
        if (this.state.sizeRanking == 0) {
          return true;
        } else if (item.size == this.state.sizeRanking) {
          return true;
        }
        return false;
      })
      .map(m => ({ value: m.city, text: m.city }))
      .uniqBy('text')
      .orderBy('value')
      .value();
  }

  public clearFilers() {
    this.state.channelRanking = 0;
    this.state.sizeRanking = 0;
    this.state.cityRanking = 0;
  }

  public getRanking() {
    this.clearFilers();
    httpService.http
      .get(
        `${CONFIG.URL.NEODASH_API}/api/directsales/ranking/rankingConsumerStore/${moment(
          this.state.dateInitial
        ).format('YYYY-MM-DD')}/${moment(this.state.dateFinal).format('YYYY-MM-DD')}/${this.state.storeSelected.value}`
      )
      .then((res: AxiosResponse) => {
        this.state.data = _(res.data)
          .map(m => ({
            id: m.id,
            salesChannelName: m.consumer.salesChannelName,
            size: m.consumer.size,
            cnpjRoot: m.consumer.cnpjRoot,
            qtdFiliais: m.qtdAffiliate,
            activityName: m.activityName,
            name: m.consumer.name,
            uf: m.consumer.uf,
            city: m.consumer.city,
            consumer: m.consumer,
            consumers: m.consumers,
            activeAssistent: m.activeAssistent,
            descriptionRangeExpectation: m.descriptionRangeExpectation,
            descriptionExpectationScore: m.descriptionExpectationScore,
            frequencyProspectValue: m.frequencyProspectValue,
            descriptionFrequencyScore: m.descriptionFrequencyScore,
            propensityScoreValue: m.propensityScoreValue * 100
          }))
          .value();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public goClient(search: any) {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_CREATE,
      params: {
        search: String(search),
        idGroup: String(this.state.groupSelected.value),
        idStore: String(this.state.storeSelected.value)
      }
    });
  }

  public goBack() {
    window.history.back();
  }

  public mounted() {
    traceLogAccess.generationTracking(PageContextName.farmerStrategy);
    this.getGroupsUser();
  }

  public getVirtualAreas() {}
}
